import { MatDialog } from "@angular/material";
import { TranslateService } from "@ngstack/translate";
import { Component, OnInit } from "@angular/core";
import { IGroup } from "src/app/interfaces/group";
import { SoundEnum } from "src/app/enums/sound.enum";
import { GroupEntryComponent } from "./group-entry/group-entry.component";
import { GroupService } from "src/app/services/http/business/group/group.service";
import { SnackBarService } from "src/app/services/common/snackBar.service";
import { GroupRouteActionService } from "src/app/services/http/business/group-route-action/group-route-action.service";

@Component({
  selector: "app-group",
  templateUrl: "./group.component.html",
  styleUrls: ["./group.component.css"]
})
export class GroupComponent implements OnInit {
  gDetail: IGroup;
  hideDetail: boolean = true;
  actions: number[];
  groupId: number;

  constructor(
    private dialog: MatDialog,
    private snackBar: SnackBarService,
    private groupService: GroupService,
    private translate: TranslateService,
    private grRouteActionService: GroupRouteActionService
  ) {}

  ngOnInit() {
    this.groupService.hideDeatail.subscribe(() => {
      this.hideDetail = true;
    });
  }

  selected(gID: number) {
    this.groupId = gID;
    this.hideDetail = false;
    this.groupService.getById(gID).subscribe(
      res => {
        this.gDetail = res;
      },
      () => {
        this.snackBar.OpenSnackBar(
          this.translate.get("error.transaction"),
          "ok",
          5000,
          SoundEnum.beep
        );
      }
    );
    this.grRouteActionService.GetActionListByGroupId(gID).subscribe(res => {
      this.actions = res.ActionList;
    });
  }

  add() {
    this.dialog
      .open(GroupEntryComponent)
      .afterClosed()
      .subscribe(() => {
        this.groupService.fire();
        this.groupService.hide();
      });
  }

  // ngOnDestroy() {
  //   this.cidService.setCID("");
  // }
}
